export default "__VITE_ASSET__DRaJ$0tG__"